import styled from "styled-components";
import { IconButton } from "@mui/material";
import { Menu } from "@mui/icons-material";
import { toggle } from "../../../../../store/redux/slice/Sidebars/adminConsoleSidebar";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";

const SidebarBtn = styled(IconButton)`
  display: inline-flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: center;
  box-sizing: border-box;
  outline: currentcolor none 0px;
  border: 0px none;
  margin: 0px;
  cursor: pointer;
  user-select: none;
  vertical-align: middle;
  appearance: none;
  text-decoration: none;
  text-transform: capitalize;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.75;
  min-height: 36px;
  transition:
    background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding: 0px;
  min-width: 0px;
  width: 36px;
  height: 36px;
  box-shadow:
    rgba(0, 0, 0, 0.2) 0px 3px 5px -1px,
    rgba(0, 0, 0, 0.14) 0px 6px 10px 0px,
    rgba(0, 0, 0, 0.12) 0px 1px 18px 0px;
  color: rgb(255, 255, 255);
  background: rgba(0, 0, 0, 0) linear-gradient(to right bottom, rgb(24, 88, 152), rgb(36, 145, 255) 120%) repeat scroll
    0% 0%;
  //border-radius: 50% 50% 50% 0;
  position: fixed;
  z-index: 1050;
  bottom: 20px;
  left: 10px;

  & svg {
    width: 17px;
  }
`;

const SidebarButton = () => {
  const dispatch = useAppDispatch();

  function handleToggle() {
    dispatch(toggle());
  }

  return (
    <SidebarBtn onClick={handleToggle}>
      <Menu />
    </SidebarBtn>
  );
};

export default SidebarButton;
